import React from "react";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/CardActions";

import useStyles from "./style";
import logo from "../../images/Logo.png";

const defaultHeader = (classes) => {
  return (
    <Typography variant="h5" component="h2" className={classes.title}>
      <img className={classes.logo} src={logo} alt="Logo Neocredit" />
    </Typography>
  );
};

const LoadingUser = (props) => {
  const sizeHeader = props.sizeHeader ? props.sizeHeader : "4.0";
  const paddingHeaderTop = props.paddingHeaderTop
    ? props.paddingHeaderTop
    : "2.8";
  const paddingHeaderBottom = props.paddingHeaderBottom
    ? props.paddingHeaderBottom
    : "3.5";

  const width = props.width ? props.width : "90";
  const height = props.height ? props.height : "90";
  const maxWidth = props.maxWidth ? props.maxWidth : "27";
  const maxHeight = props.maxHeight ? props.maxHeight : "35";
  const paddingLeft = props.paddingLeft ? props.paddingLeft : "1.8";
  const paddingRight = props.paddingRight ? props.paddingRight : "1.8";

  const classes = useStyles({
    sizeHeader,
    paddingHeaderTop,
    paddingHeaderBottom,
    width,
    height,
    maxWidth,
    maxHeight,
    paddingLeft,
    paddingRight,
  });

  const header = defaultHeader(classes);

  return (
    <div className={classes.container}>
      <Card className={classes.root} variant="outlined">
        <CardContent>
          <div className={classes.boxLayout}>
            <img className={classes.logo} src={logo} alt="Logo Neocredit" />
          </div>
          <div className={classes.boxLayout}>
            {" "}
            <Typography color="primary" component={"div"} variant="body2">
              Bem vindo,
            </Typography>
          </div>
          <div className={classes.boxLayout}>
            {" "}
            <Typography component={"div"} variant="body2">
              Estamos customizando sua experiência...
            </Typography>
          </div>
        </CardContent>
        <CardActions>{props.actions}</CardActions>
      </Card>
    </div>
  );
};

LoadingUser.propTypes = {
  sizeHeader: PropTypes.string,
  paddingHeaderTop: PropTypes.string,
  paddingHeaderBottom: PropTypes.string,
  children: PropTypes.element,
  actions: PropTypes.element,
};

export default LoadingUser;
